<div class="card mb-0">
  <div class="card-header">
    <span class="fa fa-table"></span> &nbsp; Client Account Payment
  </div>
  <div class="card-body">
    <div class="row align-items-center justify-content-start p-0">

      <div class="col-lg-6 col-sm-6">
        <div class="form-group">
          <label for="Search">Search </label>
          <div class="input-group">
            <input
            class="form-control mt-0 mb-0"
            type="text"
            style="padding: 8px; margin: 15px auto; width: 30%"
            placeholder="Search..."
            (keyup)="updateFilter($event)"
          />

          <button
            class="btn btn-outline-secondary"
            type="button"
            id="button-addon2"
          >
            <i class="fa fa-search"></i>
          </button>
          </div>
      </div>
      </div>
      <div class="col-lg-6 col-sm-6">
        <div class="form-group">
          <label for="ClientPaymentDate">Payment Date </label>
          <div class="input-group">
              <input 
                  tabindex="3" 
                  class="form-control" 
                  placeholder="dd/mm/yyyy" 
                  #ClientPaymentDate="ngModel"
                   appDateValidation
                  (dateValidationError)="onDateValidationError($event)"
                  (change)="handleChange($event)"
                  [(ngModel)]="data.ClientPaymentDate" 
                 [bsValue]="currDate"
                  name="ClientPaymentDate"
                  bsDatepicker 
                  #dp="bsDatepicker"
                  [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY',containerClass: 'theme-default', showClearButton: true,showTodayButton: true,todayPosition: 'right', clearPosition: 'right', showWeekNumbers: false }" 
                  required 
              />
              <button class="btn btn-primary" (click)="dp.toggle()" type="button"><i
                      class="far fa-calendar-alt"></i></button>
          </div>
      </div>
      </div>
    </div>
    <!--Table Rows-->

    <div class="technical-datatable responsive-datatable">
      <ngx-datatable
        #pbTable
        class="material"
        [headerHeight]="tableOptions.HeaderHeight"
        [scrollbarH]="true"
        [footerHeight]="tableOptions.FooterHeight"
        [columnMode]="tableOptions.ColumnMode"
        [rowHeight]="tableOptions.RowHeight"
        [rowClass]="getRowClass"
        (activate)="onRowActivate($event)"
        [rows]="rows"
        id="objectTable"
        [perfectScrollbar]="config"
        [limit]="10"
        [selectAllRowsOnPage]="true"
      >
        <ngx-datatable-column
          name="Action"
          [headerCheckboxable]="true"
          [width]="70"
          [sortable]="false"
          [canAutoResize]="false"
          [draggable]="false"
          [resizeable]="false"
          class="cell-center"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
            <input
              type="checkbox"
              (change)="checkboxSingleRowSelect(row)"
              [(ngModel)]="row.isSelected"
              (click)="$event.stopPropagation()"
              [ngModelOptions]="{standalone: true}"
            />
          </ng-template>
          <ng-template ngx-datatable-header-template let-selectedCount="selectedCount" let-row="row" let-rowCount="rowCount">
            <input
            type="checkbox"
            (change)="selectAllRows($event)"
            [(ngModel)]="isAllSelected"
            [ngModelOptions]="{standalone: true}"
            />
          </ng-template>
        </ngx-datatable-column>
       
        
        <ngx-datatable-column name="Transaction Type" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.TransactionType }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Transaction Description" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.TransactionDescription }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Client Name" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.ClientName }}
            </span>
          </ng-template>
        </ngx-datatable-column>


        <ngx-datatable-column name="Client Reference" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.ClientReference }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Unique Case Reference" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.CaseNumber }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Currency" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.Currency }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Invoice Number" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.InvoiceNumber }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Invoice Date" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.InvoiceDate }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Received Date" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.ReceivedDate }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Underwriter Name" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.UnderwriterName }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Market Type" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.MarketType }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Invoice Ex Vat" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.InvoiceExVat | number : '1.2-2'}}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Invoice Vat" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.InvoiceVat | number : '1.2-2'}}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Invoice Total" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.InvoiceTotal | number : '1.2-2'}}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Paid Amount" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.PaidAmount }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Due Amount" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.DueAmount }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-column name="Paid Date" [sortable]="false">
          <ng-template
            ngx-datatable-cell-template
            let-rowIndex="rowIndex"
            let-value="value"
            let-row="row"
          >
            <span>
              {{ row.PaidDate }}
            </span>
          </ng-template>
        </ngx-datatable-column>

        <ngx-datatable-footer>
          <ng-template
            ngx-datatable-footer-template
            let-rowCount="rowCount"
            let-pageSize="pageSize"
            let-selectedCount="selectedCount"
            let-curPage="curPage"
            let-offset="offset"
          >
            <div>
              <div>
                <strong> {{ selectedRowsCount }} selected out of {{ rowCount }} total</strong>
              </div>
            </div>

            <div>
              <app-datatable-pager
                [page]="curPage"
                [visiblePagesCount]="currentVisible"
                [size]="pageSize"
                [count]="rowCount"
                [hidden]="false"
                (change)="pbTable.onFooterPage($event)"
              >
              </app-datatable-pager>
            </div>
            <div style="color: #212529">
              <div></div>
            </div>
          </ng-template>
        </ngx-datatable-footer>
      </ngx-datatable>
    </div>
  </div>

  <div class="card-footer">
    <div class="text-end">
      <button type="button" (click)="select()" class="btn btn-primary">
        Create Payment
      </button>
      <button type="button" class="btn btn-dark ms-2" (click)="close()">
        Close
      </button>
    </div>
  </div>
</div>
